











































































































































































import {Component, Vue, Watch} from "vue-property-decorator"
import store from "./../store"
import {adminApiService} from "./../services/admin-api"
import EventBus from "./../eventBus"
import moment from "moment"
import {systemSrv} from "../services/system"
import router from "@/router"

@Component({
  components: {},
})
export default class JobVacancyView extends Vue {
  params
  profile:any = null

  newItemDefault = {}
  categories: any = []
  jobMatches: any = {
    docs: [],
    total: 0,
  }
  data: any = {
    id: null,
    categories: [],
    rating: null,
    item: this.newItemDefault,
    bottomSheet: false,
    bottomSheetRequest: "",
  }
  constructor() {
    super()
  }
  beforeRouteUpdate(to, from, next) {
    this.params = to.params
    this.init()
    next()
  }
  created() {
    this.params = this.$route.params
    this.profile = store.getters.profile
    this.init()
  }
  mounted() {}
  async init() {
    console.log("Initialisation of componentn", this.params)
    this.data.id = this.params["id"]
    this.load()
  }
  back() {
    this.$router.back()
  }
  viewJob(item) {
    this.$router.push({name: "jobVacancyView", params: {id: item._id}})
  }
  hire() {
    this.data.bottomSheet = true
    this.data.bottomSheetRequest = "HIRE"
  }
  async confirmRequestHire() {
    let result = await adminApiService.confirmHired(this.data.id, {})
    if (result && result.error == true) {
      EventBus.$emit("notification", {type: "error", text: "Error saving info", subtext: result.message})
      return
    }
    if (result) {
      this.data.bottomSheet = false
      EventBus.$emit("snack", {text: "Hiring Record saved Successfully"})
    }
  }
  rate() {
    this.data.bottomSheet = true
    this.data.bottomSheetRequest = "RATE"
  }
  async confirmRequestRate() {
    let rating = this.data.rating
    if (rating < 1 || rating > 5) {
      EventBus.$emit("notification", {type: "error", text: "Wrong rating value"})
      return
    }
    let result = await adminApiService.confirmRate(this.data.id, rating, {})
    if (result && result.error == true) {
      EventBus.$emit("notification", {type: "error", text: "Error saving info", subtext: result.message})
      return
    }
    if (result) {
      this.data.bottomSheet = false
      EventBus.$emit("snack", {text: "Hiring Record saved Successfully"})
    }
  }
  async load() {
    let result = await adminApiService.loadJobSeeker(this.data.id)
    if (result && result.error == true) {
      EventBus.$emit("notification", {type: "error", text: "Error loading tenant", subtext: result.message})
      return
    }
    if (result) {
      this.data.item = Object.assign({}, this.newItemDefault, result)

      this.loadMatchingJobs(this.data.item)
    }
  }

  async loadMatchingJobs(jobSeeker) {
    let malls = jobSeeker.malls
    let categories = jobSeeker.categories
    let types = jobSeeker.types
    let preferredType = jobSeeker.preferredType
    let payload = {
      malls,
      categories,
      types,
      preferredType,
    }
    let result = await adminApiService.loadMatchingJobs(payload)
    if (result && result.error == true) {
    } else {
      this.jobMatches = result
    }
  }
}
